/** Local flag image path from ISO 3166-1 alpha-2 (files in public/flags/). */
export function countryFlagUrl(isoCode) {
    if (!isoCode || typeof isoCode !== "string") {
        return null;
    }
    const code = isoCode.trim().toLowerCase();
    if (!/^[a-z]{2}$/.test(code)) {
        return null;
    }
    return `/flags/${code}.png`;
}
